export enum HomeTabs {
  ONGOING_COURSES = 'ongoing_courses',
  PAST_COURSES = 'past_courses',
}

export interface SetHomeActiveTabPayload {
  tab: HomeTabs;
}
